'use client';

import clsx from 'clsx';
import { headerStyle } from '../header.style';
import { useTopHeaderDisplay } from '@/hooks/use-top-header-display';
import { useSelectedLayoutSegments } from 'next/navigation';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';


export const HeaderContainer = ({
	children
}: {
	children: React.ReactNode
}) => {
	const canDisplayTopHeader = useTopHeaderDisplay();
	const segments = useSelectedLayoutSegments();
	const view = useAppearanceStore(state => state.view);

	return (
		<header
			className={
				clsx('header', {
					'm-display-none': !canDisplayTopHeader,
					[headerStyle.homeHeader]: segments[1] === 'lobby' && view === ViewEnum.mars,
					[headerStyle.container]: view === ViewEnum.mars,
				})
			}
		>
			{children}
		</header>
	);
}